const state = {
  routes: []
}
const getters = {
  getRoutes: state => state.routes
}
const mutations = {
  UPDATE_ROUTES: (state, array) => {
    state.routes = [ ...array ]
  }
}
const actions = {
  updateRoutes: (store, routes) => {
    const matchedRoutes = routes.map((route) => {
      return { name: route.name, path: route.path }
    })
    store.commit('UPDATE_ROUTES', matchedRoutes)
  }
}

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
}
